import Reward from './Reward'
import Detail from './Detail'
import UserAddress from './UserAddress'

export default {
  Reward, Detail, UserAddress
}



// WEBPACK FOOTER //
// ./src/components/Reward/index.js